import React, { useMemo } from 'react';

import ProjectList from '@components/ProjectList/ProjectList';
import { Box } from '@components/Restyle/index';
import ActivityIndicatorLoading from '@components/shared/ActivityIndicatorLoading';
import { useListProjectsFromQuery } from '@hooks/useListProjectsFromQuery';
import { useRefetchOnFocus } from '@hooks/useRefetchOnFocus';
import useSearch from '@hooks/useSearch';
import { useAppNavigation } from '@navigation/useAppNavigation';

export const ArchivedProjects: React.FC = () => {
  const navigation = useAppNavigation();

  const { search, filter } = useSearch();
  const {
    projects,
    loading,
    refreshControl,
    fetchFromCursor,
    refreshing,
    refetch,
  } = useListProjectsFromQuery({
    first: 25,
    archivesOnly: true,
  });

  useRefetchOnFocus(refetch, 0);

  const filteredProjects = useMemo(() => {
    if (filter.length > 0) return [];
    if (search) {
      return projects.filter((m) =>
        m?.name?.toLowerCase().includes(search.toLowerCase())
      );
    }
    return projects;
  }, [projects, search, filter]);

  if (loading) {
    return <ActivityIndicatorLoading />;
  }

  return (
    <Box flex={1}>
      <ProjectList
        projects={filteredProjects}
        onClick={navigation.navigateToProject}
        expanded={false}
        highlightedValue={search}
        loading={loading}
        alphabetical={false}
        fetchMore={fetchFromCursor}
        refreshing={refreshing}
        refreshControl={refreshControl}
      />
    </Box>
  );
};
